import { colorsPalettes, type StrictColor } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

import type { EcommerceSignalDataRowItem } from "../../models/ecommerce/EcommerceSignalColumnCellDto";

export type EcommerceTrendVisual = {
    readonly isPositive: boolean;
    readonly isNegative: boolean;
    readonly color: StrictColor;
};

export function directionToSign(direction: string): number {
    const d = direction.trim().toLowerCase();
    if (d === "grew" || d === "up" || d === "reached") {
        return 1;
    }
    if (d === "declined" || d === "down") {
        return -1;
    }
    return 0;
}

export function getEcommerceTrendVisualFromApiDirection(direction: string): EcommerceTrendVisual {
    return getEcommerceTrendVisualFromSign(directionToSign(direction));
}

export function getEcommerceTrendVisualFromSign(sign: number): EcommerceTrendVisual {
    const isPositive = sign > 0;
    const isNegative = sign < 0;
    const color = isPositive
        ? colorsPalettes.green[400]
        : isNegative
          ? colorsPalettes.red[400]
          : colorsPalettes.carbon[500];

    return { isPositive, isNegative, color };
}

export function numericChangeToTrendSign(change: number): number {
    if (change > 0) {
        return 1;
    }
    if (change < 0) {
        return -1;
    }
    return 0;
}

export function isEcommerceApiRowTransactionMetric(metric: string): boolean {
    const c = metric.replace(/\s+/g, "").toLowerCase();
    return c === "transactionvolume" || c === "onlinetransactions" || c.includes("transaction");
}

export function getEcommerceApiRowPreviousTooltipText(item: EcommerceSignalDataRowItem): string {
    const prev = item.previous_value?.trim();
    const isTransactions = isEcommerceApiRowTransactionMetric(item.metric);
    const keys = signalsI18nKeys.ecommerce.tableCellEcommerceTrendTooltip;

    if (prev) {
        return translate(isTransactions ? keys.previousOnlineTransactionsWas : keys.previousOnlineRevenueWas, {
            value: prev,
        });
    }

    return translate(isTransactions ? keys.previousOnlineTransactionsUnknown : keys.previousOnlineRevenueUnknown);
}
